import { render } from "./SearchIcon.vue?vue&type=template&id=5087c34b"
const script = {}
script.render = render

export default script